export default {
  enterpriseName: [
    {
      required: true,
      message: '请选择企业',
      trigger: 'blur',
    },
  ],
  brandName: [
    {
      required: true,
      message: '品牌名称必填',
      trigger: 'blur',
    },
  ],
  keyword: [
    {
      required: true,
      message: '关键词必填',
      trigger: 'blur',
    },
  ],
  isCompete: [
    {
      required: true,
      message: '请选择品牌归属',
      trigger: 'blur',
    },
  ],
}



// WEBPACK FOOTER //
// ./src/pages/index/views/brandWord/rules.js